import NaptimeResource from './NaptimeResource';

class NotificationPreferences extends NaptimeResource {
  static RESOURCE_NAME = 'notificationPreferences.v2';

  declare global: string;

  declare reminders: { email: string; push: string };

  declare courses: { email: string; push: string };

  declare promotions: { email: string; push: string };

  declare recommendations: { email: string; push: string };

  declare volunteer: { email: string; push: string };
}

export type NotificationPreferencesV2Type = {
  global: string;
  reminders: {
    email: string;
    push: string;
  };
  courses: {
    email: string;
    push: string;
  };
  promotions: {
    email: string;
    push: string;
  };
  recommendations: {
    email: string;
    push: string;
  };
  volunteer: {
    email: string;
    push: string;
  };
  enterpriseMarketing?: {
    email: string;
  };
};

export default NotificationPreferences;
